import { render, staticRenderFns } from "./RequestToImproveNotificationModal.vue?vue&type=template&id=001e1d4f&scoped=true"
import script from "./RequestToImproveNotificationModal.vue?vue&type=script&lang=js"
export * from "./RequestToImproveNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./RequestToImproveNotificationModal.vue?vue&type=style&index=0&id=001e1d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e1d4f",
  null
  
)

export default component.exports